import PropTypes from 'prop-types';
import React from 'react';
import FocusLock from 'react-focus-lock';
import Sidebar from 'semantic-ui-react/dist/commonjs/modules/Sidebar';
import '@purple/semantic-ui-purple-theme/components/sidebar.css';
import omit from 'lodash/omit';

/**
 * Enhancing Slide bar to capture focus when slide bar is open and to prop onClose when ESCAPE key is pressed.
 */
class EnhancedSidebar extends React.PureComponent {
  static propTypes = {
    ...Sidebar.propTypes,
    onClose: PropTypes.func,
  };

  state = {
    focusLockDisabled: true, // disabled until sidebar has shown.
  };

  componentDidMount() {
    document.addEventListener('keydown', this.closeOnEscape);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.closeOnEscape);
  }

  onShow = (...args) => {
    /* istanbul ignore else */
    if (this.props.visible) {
      this.setState({ focusLockDisabled: false });
      if (this.props.onShow) {
        this.props.onShow(...args);
      }
    }
  };

  onHidden = (...args) => {
    this.setState({ focusLockDisabled: true });
    if (this.props.onHidden) {
      this.props.onHidden(...args);
    }
  };

  closeOnEscape = (e) => {
    if (e.keyCode === 27 && this.props.onClose) {
      e.preventDefault();
      this.props.onClose();
    }
  };

  render() {
    return (
      <Sidebar
        {...omit(this.props, 'children', 'onShow', 'onHidden')}
        onShow={this.onShow}
        onHidden={this.onHidden}
        aria-hidden={!this.props.visible}
      >
        {this.props.children && (
        <FocusLock disabled={!this.props.visible || this.state.focusLockDisabled} returnFocus>
          {this.props.children}
        </FocusLock>
        )}
      </Sidebar>
    );
  }
}

// Copy Other Sidebar properties to the enhancedSidebar, because we use Sidebar.Pushable and Sidebar.Pusher
EnhancedSidebar.Pusher = Sidebar.Pusher;
EnhancedSidebar.Pushable = Sidebar.Pushable;

export default EnhancedSidebar;
